import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useParams } from 'react-router-dom';
import SchoolHeader from '../components/SchoolHeader';
import SchoolHero from '../components/SchoolHero';
import SchoolAbout from '../components/SchoolAbout';
import SchoolFacilities from '../components/SchoolFacilities';
import SchoolAdmissionStaff from '../components/SchoolAdmissionStaff';
import SchoolGallery from '../components/SchoolGallery';
import TrustFooter from '../components/TrustFooter';
import ContactCard from '../components/ContactCard';
import SchoolMap from '../components/SchoolMap';

import suyog from '../assets/suyog.png';
import president from '../assets/president.png';
import vishamber from '../assets/vishamber.png';
import ram from '../assets/ram.png';
import hg_main from '../assets/hg_main.png';
import hg1 from '../assets/hg1.png';
import hg2 from '../assets/hg2.png';
import hg3 from '../assets/hg3.png';
import hg4 from '../assets/hg4.png';
import hg5 from '../assets/hg5.jpeg';
import hg6 from '../assets/hg6.jpeg';
import hin_main from '../assets/hin_main.jpeg';
import hin1 from '../assets/hin1.png';
import hin2 from '../assets/hin2.png';
import hin4 from '../assets/hin4.jpeg';
import riyan from '../assets/riyan.png';
import irfan from '../assets/irfan.png';
import sg1 from '../assets/sg1.png';
import sg2 from '../assets/sg2.png';
import sg3 from '../assets/sg3.png';
import sg4 from '../assets/sg4.png';
import sg5 from '../assets/sg5.png';
import sg6 from '../assets/sg6.png';
import sg_main from '../assets/sg_main.png';
import { MapPin, Phone, Mail } from 'lucide-react';
// import irfan from '../assets/irfan.jpg';

const schoolsInfo = {
  badhir: {
    name: 'NIWASI MUKBADHIR VIDYALAY, HADGAON',
    shortName: 'NIWASI MUKBADHIR VIDYALAY, HADGAON',
    tagline: 'Empowering Rural Education',
    heroImage: hg_main,
    description: 'Founded with the dream of bringing quality education to remote areas, NIWASI MUKBADHIR VIDYALAY, HADGAON has been a beacon of hope for countless families.',
    vision: 'To provide world-class education to deaf and rural children, ensuring no child is left behind due to geographical or economic constraints.',
    mission: 'Nurturing young minds with quality education, traditional values, and modern skills to create responsible global citizens.',
    values: 'Excellence, integrity, compassion, and innovation form the cornerstone of our educational philosophy and daily practice.',
    stats: {
      students: 60,
      teachers: 24,
      successRate: 90,
      legacy: 30
    },
    principal: {
      name: 'Mrs. Vishamber shivshankar Khakare',
      role: 'School Principal',
      email: 'nmvhadgav@gmail.com',
      phone: '+91 96232 20403',
      image: vishamber
    },
    leadership: [
      {
        name: 'Dr. W R MUJAWAR',
        role: 'President Of School Trust',
        image: president
      },
      {
        name: 'Mr. RIYAN MUJAWAR  ',
        role: 'Secretary Of School Trust',
        image: riyan
      },
      {
        name: 'Mr. IRFAN MUJAWAR  ',
        role: 'Member Of School Trust',
        image: irfan
      }
    ],
    facilities: [
      {
        name: 'Smart Classrooms',
        description: 'Digital boards and multimedia learning tools',
        icon: 'BookOpen'
      },
      {
        name: 'Green Campus',
        description: 'Eco-friendly environment with open spaces',
        icon: 'TreePine'
      },
      {
        name: 'Sports Facilities',
        description: 'Playground and indoor games for physical development',
        icon: 'Trophy'
      },
      {
        name: 'Library',
        description: 'Well-stocked library with diverse collections',
        icon: 'Library'
      },
      {
        name: 'Healthcare',
        description: 'Regular health checkups and first-aid facilities',
        icon: 'Heart'
      },
      {
        name: 'Arts & Music',
        description: 'Dedicated spaces for creative expression',
        icon: 'Music'
      },
      {
        name: 'Computer Lab',
        description: 'Facility for computer education',
        icon: 'Computer'
      },
      {
        name: 'Hearing Instrument',
        description: 'Facility for hearing instrument',
        icon: 'Heart'
      },
      {
        name: 'Free Hostel Fascility',
        description: 'Facility for hostel',
        icon: 'Home'
      }
    ],
    galleryImages: [
      hg1,
      hg5,
      hg3,
      hg6,
      hg4,
      hg2,
    ],
    contact: {
      address: 'NIWASI MUKBADHIR VIDYALAY,Tamsa Road,Near Bhadant Tekdi,TA-HADGAON, District-NANDED',
      phone: '+91 96232 20403',
      email: 'nmvhadgav@gmail.com'
    }
  },
  prathamik: {
    name: 'NIWASI MUKBADHIR VIDYALAY, SAVARGAON(PIR)',
    shortName: 'NIWASI MUKBADHIR VIDYALAY, SAVARGAON(PIR)',
    tagline: 'Building Strong Foundations',
    heroImage: sg_main,
    description: 'NIWASI MUKBADHIR VIDYALAY, SAVARGAON focuses on elementary education, providing a nurturing environment for young learners to develop strong foundations in academics and character.',
    vision: 'To create confident, capable learners who are equipped with strong fundamentals and a love for learning.',
    mission: 'Building strong foundations through innovative teaching methods, personalized attention, and holistic development.',
    values: 'Curiosity, creativity, collaboration, and character development guide every aspect of our primary education.',
    stats: {
      students: 60,
      teachers: 24,
      successRate: 88,
      legacy: 30
    },
    principal: {
      name: 'Mr. Suyog Vijayakumar Itgyalkar(M.A. B.ed (HI))',
      role: 'School Principal',
      email: 'suyogitgyalkar@gmail.com',
      phone: '+91 95032 82610',
      image: suyog
    },
    leadership: [
      {
        name: 'Dr. W R MUJAWAR',
        role: 'President Of School Trust',
        image: president
      },
      {
        name: 'Mr. RIYAN MUJAWAR  ',
        role: 'Secretary Of School Trust',
        image: riyan
      },
      {
        name: 'Mr. IRFAN MUJAWAR  ',
        role: 'Member Of School Trust',
        image: irfan
      }
    ],
    facilities: [
      {
        name: 'Play-Based Learning',
        description: 'Interactive and engaging learning environment',
        icon: 'BookOpen'
      },
      {
        name: 'Sound Treated Rooms',
        description: 'Sound treated rooms for better learning environment',
        icon: 'Palette'
      },
      {
        name: 'Safe Campus',
        description: 'Child-safe infrastructure with constant supervision',
        icon: 'Shield'
      },
      {
        name: 'Activity Rooms',
        description: 'Dedicated spaces for art, craft, and play',
        icon: 'Palette'
      },
      {
        name: 'Kids Library',
        description: 'Age-appropriate books and reading programs',
        icon: 'Library'
      },
      {
        name: 'Health & Nutrition',
        description: 'Mid-day meals and health monitoring',
        icon: 'Apple'
      },
      {
        name: 'Outdoor Play',
        description: 'Safe playground for physical activities',
        icon: 'TreePine'
      },
      {
        name: 'Early Intervention Program(EIP) Center',
        description: 'EIP Center for young children with developmental delays, offering therapy (speech, OT) and skills training',
        icon: 'BookOpen'
      },
    ],
    galleryImages: [
      sg1,
      sg2,
      sg3,
      sg4,
      sg5,
      sg6,  
    ],
    contact: {
      address: 'NIWASI MUKBADHIR VIDYALAY, SAVARGAON(PIR) ,TQ-MUKHED , District- NANDED(431715)',
      phone: '+91 95032 82610',
      email: 'suyogitgyalkar@gmail.com',
      mapsUrl: 'https://maps.app.goo.gl/H4YBWnjNQCWL3BP86',
      embedUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3779.9479843814206!2d77.2618817!3d18.66633!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bce4b8d6bcb1fe9%3A0x6dc9274a34efe093!2sNiwaci%20Mukbdhir%20Vidaylay!5e0!3m2!1sen!2sin!4v1768235792154!5m2!1sen!2sin'
    }
  },
  madhyamik: {
    name: 'APANG NIWASI VIDYALAY, HINGOLI',
    shortName: 'APANG NIWASI VIDYALAY, HINGOLI',
    tagline: 'Nurturing Excellence',
    heroImage: hin_main,
    description: 'APANG NIWASI VIDYALAY, HINGOLI offers comprehensive secondary education, preparing students for higher studies and future careers with a focus on academic excellence and holistic development.',
    vision: 'To develop well-rounded individuals who excel academically and contribute positively to society.',
    mission: 'Delivering excellence in secondary education through rigorous academics, modern facilities, and values-based learning.',
    values: 'Academic rigor, critical thinking, ethical leadership, and social responsibility define our approach to secondary education.',
    stats: {
      students: 40,
      teachers: 20,
      successRate: 92,
      legacy: 12
    },
    principal: {
      name: 'Mr. Ramsingh Chavan',
      role: 'School Principal',
      email: 'ramsingchavan343@gmail.com',
      phone: '+91 86689 19390',
      image: ram
    },
    leadership: [
      {
        name: 'Dr. W R MUJAWAR',
        role: 'President Of School Trust',
        image: president
      },
      {
        name: 'Mr. RIYAN MUJAWAR  ',
        role: 'Secretary Of School Trust',
        image: riyan
      },
      {
        name: 'Mr. IRFAN MUJAWAR  ',
        role: 'Member Of School Trust',
        image: irfan
      }
    ],
    facilities: [
      {
        name: 'Science Labs',
        description: 'Well-equipped physics, chemistry, and biology labs',
        icon: 'Microscope'
      },
      {
        name: 'Computer Lab',
        description: 'Modern computing facilities with internet access',
        icon: 'Monitor'
      },
      {
        name: 'Sports Complex',
        description: 'Indoor and outdoor sports facilities',
        icon: 'Trophy'
      },
      {
        name: 'Library & Research',
        description: 'Extensive collection and digital resources',
        icon: 'Library'
      },
      {
        name: 'Career Guidance',
        description: 'Counseling and career development support',
        icon: 'Briefcase'
      },
      {
        name: 'Auditorium',
        description: 'Modern facility for events and assemblies',
        icon: 'Building'
      }
    ],
    galleryImages: [
      hin4,
      hin1,
      hin2,
      // hin3
    ],
    contact: {
      address: 'APANG NIWASI VIDYALAY, Near MIDC, District- Hingoli-431513',
      phone: '+91 86689 19390',
      email: 'contact@madhyamikvidyalay.edu.in'
    }
  }
};

const SchoolPage = () => {
  const { schoolId } = useParams();
  const [activeSection, setActiveSection] = useState('home');
  const school = schoolsInfo[schoolId];

  if (!school) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <h1 className="text-2xl text-foreground">School not found</h1>
      </div>
    );
  }

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
      className="min-h-screen bg-background"
    >
      <SchoolHeader
        schoolName={school.shortName}
        activeSection={activeSection}
        setActiveSection={setActiveSection}
      />

      {activeSection === 'home' && <SchoolHero school={school} />}
      {activeSection === 'about' && <SchoolAbout school={school} />}
      {activeSection === 'facilities' && <SchoolFacilities school={school} />}
      {activeSection === 'admission' && <SchoolAdmissionStaff school={school} />}

      {activeSection === 'home' && <SchoolGallery images={school.galleryImages} />}
      {activeSection === 'home' && (
        <section className="py-16 px-4 sm:px-6 lg:px-8 bg-background">
          {/* Heading Section */}
          <div className="max-w-7xl mx-auto mb-12">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
              className="text-center"
            >
              <h2 className="text-3xl sm:text-4xl font-display font-bold text-foreground mb-4">
                Get In Touch
              </h2>
              <div className="w-24 h-1 bg-gradient-warm mx-auto rounded-full mb-6"></div>
              <p className="text-lg text-muted-foreground">
                We're here to answer your questions and help you connect with us
              </p>
            </motion.div>
          </div>

          {/* Contact Cards Grid */}
          <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8">
            <ContactCard
              icon={MapPin}
              title="Visit Us"
              items={[school.contact.address]}
              iconColor="orange"
            />
            <ContactCard
              icon={Phone}
              title="Call Us"
              items={[school.contact.phone]}
              iconColor="green"
              linkType="phone"
            />
            <ContactCard
              icon={Mail}
              title="Email Us"
              items={[school.contact.email]}
              iconColor="orange"
              linkType="email"
            />
          </div>

          <div className="max-w-7xl mx-auto mt-12">
            <SchoolMap
              address={school.contact.address}
              mapsUrl={school.contact.mapsUrl}
              embedUrl={school.contact.embedUrl}
            />
          </div>
        </section>
      )}
      <TrustFooter />
    </motion.div>
  );
};

export default SchoolPage;
